<!--
  camera-test.component.html
  Test component for validating camera functionality in a PWA context.
  Supports photo capture via getUserMedia and QR code scanning via ZXing.
-->

<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title>Camera Testing</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- Initial State: mode selection -->
  <div *ngIf="!isQrMode && !capturedPhoto && !detectedQrCode">
    <ion-card>
      <ion-card-content class="ion-text-center">
        <ion-icon name="camera-outline" style="font-size: 64px;"></ion-icon>
        <ion-text>
          <h2>Camera Testing</h2>
          <p>Select an option below to test camera functionality</p>
        </ion-text>
        <ion-button expand="block" color="primary" class="ion-margin-top" (click)="openCameraForPhoto()">
          <ion-icon slot="start" name="camera"></ion-icon>
          Take a Photo
        </ion-button>
        <ion-button expand="block" color="secondary" class="ion-margin-top" (click)="openCameraForQrScan()">
          <ion-icon slot="start" name="qr-code"></ion-icon>
          Scan QR Code (V2)
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>




<!-- Photo Preview: review and confirm or retake -->
<div *ngIf="capturedPhoto">
  <ion-card>
    <ion-card-content>
      <ion-text><h3 class="ion-text-center">Photo Preview</h3></ion-text>
      <img [src]="capturedPhoto" alt="Captured Photo" style="width: 100%; border-radius: 8px;" />
      <ion-button expand="block" color="success" class="ion-margin-top" (click)="usePhoto()">
        <ion-icon slot="start" name="checkmark"></ion-icon>
        Use Photo
      </ion-button>
      <ion-button expand="block" color="danger" class="ion-margin-top" (click)="retakePhoto()">
        <ion-icon slot="start" name="refresh"></ion-icon>
        Retake
      </ion-button>
      <ion-button expand="block" color="light" class="ion-margin-top" (click)="close()">
        <ion-icon slot="start" name="close"></ion-icon>
        Cancel
      </ion-button>
    </ion-card-content>
  </ion-card>
</div>

  <!-- QR Scan Mode: full width scanner, auto-closes on detect -->
  <div *ngIf="isQrMode && !detectedQrCode">
    <div class="ion-text-center ion-padding">
  <ion-spinner *ngIf="!cameraReady"></ion-spinner>
  <p>{{ statusMessage }}</p>
</div>
<zxing-scanner
  #scanner
  [device]="selectedDevice"
  [videoConstraints]="videoConstraints"
  [tryHarder]="tryHarder"
  [formats]="qrFormats"
  (camerasFound)="onCamerasFound($event)"
  (permissionResponse)="onPermission($event)"
  (scanError)="onScanError($event)"
  (scanComplete)="onScanComplete($event)"
  (scanSuccess)="onQrCodeResult($event)">
</zxing-scanner>
    <ion-text class="ion-text-center">
      <p>{{ statusMessage }}</p>
    </ion-text>
    <ion-button expand="block" color="light" class="ion-margin-top" (click)="closeCamera()">
      <ion-icon slot="start" name="close"></ion-icon>
      Cancel
    </ion-button>
  </div>

  <!-- QR Result: show detected value -->
  <div *ngIf="detectedQrCode">
    <ion-card>
      <ion-card-content class="ion-text-center">
        <ion-icon name="checkmark-circle" color="success" style="font-size: 64px;"></ion-icon>
        <ion-text>
          <h3>QR Code Detected</h3>
          <h2 color="primary">{{ detectedQrCode }}</h2>
        </ion-text>
        <ion-button expand="block" color="success" class="ion-margin-top" (click)="close()">
          <ion-icon slot="start" name="checkmark"></ion-icon>
          Done
        </ion-button>
        <ion-button expand="block" color="light" class="ion-margin-top" (click)="openCameraForQrScan()">
          <ion-icon slot="start" name="camera"></ion-icon>
          Scan Another
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>

</ion-content>